import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  connect() {
    this.element.querySelectorAll("a").forEach((link) => {
      if (
        link.href.startsWith("/") ||
        new URL(link.href).host === new URL(window.location).host
      ) {
        // Navigate the page (not a nested frame such as a comment's); the
        // page-content frame advances history itself.
        link.dataset.turboFrame = "page-content";
      }
    });
    this.element.querySelectorAll(".attachment a").forEach((link) => {
      delete link.dataset.turboFrame;
    });
  }
}
